import React, { useCallback, useState } from 'react';
import { ButtonSection, GroupBody, GroupModel } from '../createGroupModal/styles';
import Button from '../../button';
import { addStatusData, getCurrentProjectDetails, updateStatusData } from '../../../services/projectServices';
import { nanoid } from 'nanoid';
import { StatusListInterface } from '../../../interfaces/ProjectInterface';
import { rootStore } from '../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import { BUTTON_TYPE } from '../../../global/constants';
import ModalHeader from '../modalHeader';
import Input from '../../input';

interface Props {
  onCancel: () => void;
  statusType: number;
  projectId: string;
  isTemplateProject?: boolean;
  statusData?: StatusListInterface | null;
}

const AddStatusModal: React.FC<Props> = (props) => {
  const { onCancel, statusType, projectId, isTemplateProject, statusData } = props;
  //States
  const [loading, setLoading] = useState(false);
  const [statusName, setStatusName] = useState(statusData?.Name || '');
  //Mobx store variables
  const { projectStore, projectTemplateStore } = rootStore;
  const { currentProject } = projectStore;
  const { currentProjectTemplate } = projectTemplateStore;

  const onCloseModal = useCallback(() => {
    onCancel();
  }, [onCancel]);

  const handleChangeDetails = useCallback((value: string) => {
    setStatusName(value);
  }, []);

  const updateTemplateProjectData = useCallback(() => {
    if (statusData?.['_id']) {
      const updatedStatusList =
        currentProjectTemplate?.statusData?.map((status) => {
          if (status?.['_id'] === statusData?.['_id']) {
            return { ...(status || {}), Name: statusName };
          } else return status;
        }) || [];
      currentProjectTemplate?.setStatusData(updatedStatusList);
    } else {
      const newStatus = {
        _id: nanoid(),
        Type: statusType,
        Name: statusName,
        Index: new Date().getTime(),
        Default: false
      };

      const updatedStatusList = [...(currentProjectTemplate?.statusData || []), newStatus];
      currentProjectTemplate?.setStatusData(updatedStatusList);
    }
  }, [statusData, currentProjectTemplate, statusName, statusType]);

  const onSubmit = useCallback(
    async (e: React.SyntheticEvent) => {
      setLoading(true);
      try {
        e.preventDefault();
        if (isTemplateProject) {
          updateTemplateProjectData();
        } else {
          if (statusData?.['_id']) {
            const payload = {
              name: statusName
            };
            const updatedStatus =
              currentProject?.statusData?.map((x) => {
                if (x['_id'] === statusData?.['_id']) {
                  return { ...x, Name: statusName };
                } else return x;
              }) || [];
            currentProject?.setStatusData(updatedStatus);
            await updateStatusData(projectId, statusData?.['_id'], payload);
          } else {
            const payload = {
              index: new Date().getTime(),
              name: statusName,
              type: statusType
            };
            const newStatus = {
              _id: nanoid(),
              Type: statusType,
              Name: statusName,
              Index: new Date().getTime()
            };
            const updatedStatus = [...(currentProject?.statusData || []), newStatus];
            currentProject?.setStatusData(updatedStatus);
            await addStatusData(projectId, payload);
            getCurrentProjectDetails(projectId);
          }
        }
      } catch (error) {
        console.log('error', error);
      } finally {
        setLoading(false);
        onCancel();
      }
    },
    [
      currentProject,
      isTemplateProject,
      onCancel,
      projectId,
      statusData,
      statusName,
      statusType,
      updateTemplateProjectData
    ]
  );

  return (
    <GroupModel onSubmit={onSubmit}>
      <ModalHeader title={statusData?.['_id'] ? 'Edit Status' : 'Add status'} onClose={onCloseModal} />
      <GroupBody>
        <Input
          label='Status name'
          autoFocus={true}
          placeHolder={statusData?.['_id'] ? 'Enter new status name' : 'Enter your status name'}
          value={statusName}
          onChange={(e) => handleChangeDetails(e.target.value)}
        />
        <ButtonSection>
          <Button
            variant={BUTTON_TYPE.PRIMARY}
            buttonType={'submit'}
            title={statusData?.['_id'] ? 'Edit Status' : 'Add Status'}
            isLoading={loading}
          />
        </ButtonSection>
      </GroupBody>
    </GroupModel>
  );
};
export default observer(AddStatusModal);
